import React from 'react';
import { List } from './UiImageSet.styles';
import { renderViewModel } from '../../render-view-model';
export default function UiImageSet({ model: { content: { images, justified } } }) {
    return (React.createElement(List, { justified: justified }, images.map((image, index) => (React.createElement("li", { key: `${image.id}_${index}` }, renderViewModel(image))))));
}
//# sourceMappingURL=UiImageSet.js.map